<template>
  <v-container fluid v-if="asyncDataStatus_ready">
    <div class="dashboard-page">
      <v-card width="100%" class="breadcrumbs mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-md-start justify-space-between align-center"
          >
            <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Pessoas Alcançadas pelo Projeto
            </h1>
            <div class="py-6"></div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
            <v-btn
              outlined
              color="primary"
              class="text-capitalize text button-shadow mb-3 mb-sm-0"
              :to="{ name: 'RelatorioPessoas' }"
              >Relatórios</v-btn
            >
            <NovaPessoa v-if="isPermissao"></NovaPessoa>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="12">
          <v-card width="100%" class="support-table ma-1">
            <v-card-text>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Busca"
                single-line
                hide-details
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pa-0 overflow-x-auto">
              <v-data-table
                :search="search"
                :headers="headers"
                :items="listaPessoasAlcancadas"
                sort-by="nome"
                no-results-text="Nenhuma pessoa encontrada"
                no-data-text="Não há pessoas registradas"
                :items-per-page="itemPerPage"
              >
                <template v-slot:item.nome="{ item }">
                  <span class="mb-0 fs-base">{{ item.nome }}</span>
                </template>
                <template v-slot:item.idade="{ item }">
                  <span class="mb-0 fs-base">{{ item.idade }}</span>
                </template>
                <template v-slot:item.genero="{ item }">
                  <span class="mb-0 fs-base">{{ generos[item.genero].nome }}</span>
                </template>
                <template v-slot:item.estado="{ item }">
                  <span class="mb-0 fs-base">{{ estados[item.estado].nome }}</span>
                </template>
                <template v-slot:item.pais="{ item }">
                  <span class="mb-0 fs-base">{{ paises[item.pais].nome }}</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-right">
                    <v-btn
                      v-if="isPermissao"
                      class="mr-2"
                      @click="excluir(item)"
                      color="error text-center"
                      small
                      >Excluir</v-btn
                    >
                    <EditaPessoa v-if="isPermissao" :pessoa="item"></EditaPessoa>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <Confirm ref="confirm"></Confirm>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from "@/mixins/asyncDataStatus";
import NovaPessoa from "./Nova/NovaPessoa";
import EditaPessoa from "./Edita/EditaPessoa";
import Confirm from "@/components/Dialog/Confirm";

export default {
  name: "Pessoas",
  components: {
    NovaPessoa,
    EditaPessoa,
    Confirm,
  },
  mixins: [asyncDataStatus],
  data() {
    return {
      search: "",
      headers: [
        { text: "Nome", value: "nome", filterable: true },
        { text: "Idade", value: "idade", filterable: true },
        { text: "Gênero", value: "genero", filterable: true },
        { text: "Estado", value: "estado", filterable: true },
        { text: "País", value: "pais", filterable: true },
        { text: "", value: "actions", sortable: false },
      ],
      itemPerPage: 20,
    };
  },
  methods: {
    ...mapActions("pessoaAlcancada", [
      "fetchPessoasAlcancadasByProjeto",
      "deletePessoaAlcancada",
    ]),

    excluir(item) {
      this.$refs.confirm
        .open("Excluir Pessoa", item.nome, "Você tem certeza?", {})
        .then((confirm) => {
          if (confirm) {
            let payload = {
              projetoId: parseInt(this.$route.params.projetoId),
              pessoaAlcancadaId: item.id,
            };
            this.deletePessoaAlcancada(payload);
          }
        });
    },
  },
  computed: {
    listaPessoasAlcancadas() {
      return this.$store.getters["pessoaAlcancada/byProjetoId"](
        parseInt(this.$route.params.projetoId)
      );
    },

    isPermissao() {
      return this.$store.getters["auth/isAdministrador"];
    },

    estados() {
      return this.$store.getters["enums/estados"];
    },

    generos() {
      return this.$store.getters["enums/generos"];
    },

    paises() {
      return this.$store.getters["enums/paises"];
    },
  },

  created() {
    Promise.all([
      this.fetchPessoasAlcancadasByProjeto(this.$route.params.projetoId),
    ]).then(() => {
      this.asyncDataStatus_fetched();
    });
  },
};
</script>

<style src="./PessoasAlcancadas.scss" lang="scss" />
